module.exports = __webpack_public_path__ + "assets/img/teb@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/teb@2x.png
// module id = 141
// module chunks = 0